import { useEffect, useState } from 'react';

import { getByKey } from 'utils';

type EsportIconsPack = typeof import('assets/esport-icons-pack')['default'];

type ClassicIconsPack = typeof import('assets/classic-icons-pack')['default'];

let esportIconsPack: EsportIconsPack | null = null;
let classicIconsPack: ClassicIconsPack | null = null;

interface Input {
    gameId: string;
}

interface Output {
    glyph: any;
}

const loadEsportIconsPack = (callback: VoidFn) =>
    import(
        /* webpackChunkName: "esport-icons" */ 'assets/esport-icons-pack'
    ).then(svgPack => {
        esportIconsPack = svgPack.default;
        callback();
    });

const loadClassicIconsPack = (callback: VoidFn) =>
    import(
        /* webpackChunkName: "classic-icons" */ 'assets/classic-icons-pack'
    ).then(svgPack => {
        classicIconsPack = svgPack.default;
        callback();
    });

const useGameLogo = ({ gameId }: Input): Output => {
    const isEsport = gameId.includes('esport');
    const [, forceUpdate] = useState<number>(0);

    useEffect(() => {
        if (
            getByKey(esportIconsPack, gameId) ||
            getByKey(classicIconsPack, gameId)
        )
            return;

        const callback = () => forceUpdate(s => ++s);

        if (isEsport) {
            loadEsportIconsPack(callback);
        } else {
            loadClassicIconsPack(callback);
        }
    }, [gameId, isEsport]);

    return {
        glyph:
            getByKey(esportIconsPack, gameId) ||
            getByKey(classicIconsPack, gameId),
    };
};

export default useGameLogo;
